/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["a[_ngcontent-%COMP%] {\n  color: black !important; }"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/profile-register/profile-register.component.scss.shim.ngstyle.js.pre-build-optimizer.js